import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export type BasemapId =
  | "outdoor-v2"
  | "topo-v2"
  | "satellite"
  | "satellite-hybrid";

type MapSettingsState = {
  basemap: BasemapId;
};

const initialState: MapSettingsState = {
  basemap: "outdoor-v2",
};

const mapSettings = createSlice({
  name: "mapSettings",
  initialState,
  reducers: {
    setBasemap: (state, action: PayloadAction<BasemapId>) => {
      state.basemap = action.payload;
    },
  },
});

export const { setBasemap } = mapSettings.actions;

export default mapSettings.reducer;

// Simple selector - no transformation needed, so no need for createSelector
const selectBasemap = (state: RootState) => state.mapSettings.basemap;

export const useBasemap = () => {
  return useSelector(selectBasemap);
};
